import React , {useState,useEffect} from 'react'
import small_square from '../images/small_square.svg'
import small_checkmark from '../images/small_checkmark.svg'
import semiCheckbox from '../images/Semi-checked.svg'

import alertIcon from '../images/Icon-Altert_Small.png';

function TriCheckbox2({data,ticket,object_with_status, chosedtickets,add,index,tktDetailShown}) {
//    const key = sessionStorage.getItem("key");
   const ticketTypesAdd    = data.flatMap((i) =>  i.eventObject.TicketTypes_Add?.length ? i.eventObject.TicketTypes_Add : [])

   const ticketTypesRemove = data.flatMap((i) =>  i.eventObject.TicketTypes_Remove?.length ? i.eventObject.TicketTypes_Remove : [])

   const [clicked, setclicked] = useState(false);
   let removed = ticketTypesRemove.find((tk) => {return tk.No ===ticket.No})
  const [showAlert, setShowAlert] = useState(false);
  const [count, setCount] = useState(statusChange(ticket.No) === 1 ? 1 :  removed?.No  === ticket.No ? 2 : 0);


  function checkForAlertonChosen(item){
    let showAlert    
    // let ticketTypesAdd = data.map((i) =>  i.eventObject.TicketTypes_Add)
    // console.log(item, 'ticket')
    // console.log(ticketTypesAdd, 'ticket type add')
    ticketTypesAdd.length > 0 && ticketTypesAdd.map(tr => {
      //  console.log(tr, 'tr')
      //  console.log(item)
      if (tr.No === item.No) {
          showAlert = true
       return showAlert
      }      
     })    
      //  console.log(showAlert, 'show alert')
    return showAlert
  }
  
  // console.log(ticketTypesRemove, 'tickets removedn ')
  function checkForAlertonNotChosen(item){
    let showAlert    
    // let ticketTypesRemove = data.map((i) => { return i.eventObject.TicketTypes_Remove})
    // console.log(ticketTypesRemove)
    ticketTypesRemove.length > 0 && ticketTypesRemove?.map(tr => {
      //  console.log(tr, 'tr')
      if (tr.No === item.No) {
          showAlert= true
       return showAlert
      }      
     })    
    //  console.log(showAlert)
  
    return showAlert
  }

    function increase (tkt) {  
       setclicked(true)
        setCount( count < 3 ? count+1 : 1)    //if count is 0 semicheckbox, if count is 1 checkmark, if count is 2 square
        console.log(count, 'count')  
        // checkForAlertonChosen(tkt)
    }
    // console.log(check1(ticket))

    function statusChange (No) {
      let status 
      
     object_with_status.map((obj) => {
       if(obj.status === 0 && obj.No === No) {
         status = 0
         return status
       }
       else if(obj.status === 2 && obj.No === No) {
        status = 2
        return status
       }
       else chosedtickets?.map((item) => {
        if(item?.No === No) {
         status = 1 // returns 1 if ticket.No exists in chosedTickets
        }
        return status
    })
    return status
    
     })
     
     return status
    }
    



     useEffect(() => {
      if(clicked === true) { 
        // console.log(count, 'count from useeffect')
        if(count == 1) {     
           data.map((item) => {
            let theEvent = item.eventObject    
      //  console.log(ticketTypesAdd, 'ticket type add from ')

           // if the event ticket type does not include ticket.No then add ticket.No to tickettype_add 
             theEvent?.TicketTypes?.some(el => el?.No === ticket?.No) ?
               console.log(theEvent, 'events where no exists') 
      //      theEvent.TicketTypes_Add =  []
        :        
          (
          
        ticketTypesAdd[0] ?         
        theEvent?.TicketTypes_Add?.push({No:ticket.No})     
         : theEvent.TicketTypes_Add = [{No:ticket.No}]     
         )
   
    setShowAlert(true)
    // checkForAlertonChosen(theEvent,ticket)

      })

        }
        else if(count == 2 ) {
            console.log('second click')
                   data.map((item) => {
                      let theEvent = item.eventObject   
                      theEvent?.TicketTypes?.some(el => el?.No === ticket?.No) ?
                      (
                           ticketTypesRemove[0] ?   
                           theEvent.TicketTypes_Remove.push({No:ticket.No}) 
                         : theEvent.TicketTypes_Remove =  [{No:ticket.No}]   // before it was removes
                        // console.log(theEvent, 'ticket.No exists here so add ticket.No ro remove')

                        )  
                        : 
                        theEvent.TicketTypes_Add=  theEvent.TicketTypes_Add?.filter(e => e.No !== ticket?.No)
                                 
                      
                       setShowAlert(true)
                      })
        }
        else if(count == 3) {
          console.log('third click')
          data.map((item) => {
         
            let theEvent = item.eventObject
            if(theEvent.TicketTypes_Add !== null && theEvent?.TicketTypes_Add?.some(el => el.No === ticket?.No)) {
              theEvent.TicketTypes_Add=  theEvent.TicketTypes_Add?.filter(e => e.No !== ticket?.No)  

            }
            if(theEvent.TicketTypes_Remove !== null && theEvent?.TicketTypes_Remove?.some(el => el.No === ticket.No)) {
              theEvent.TicketTypes_Remove =  theEvent.TicketTypes_Remove?.filter(e => e.No !== ticket?.No)
            }
            setShowAlert(false)
     
         })
        }

        else {
        }
}
     },[count,data,ticket,clicked]);
   
 
   
  return (
    <div key={index} style={{display:'grid',
        gridTemplateColumns:'.11fr 1fr .1fr',fontSize:'12px',height:'18px',padding:'0px'}}>
        
            <img  onClick={()=>increase(ticket)} style={{padding:'2px',height:'19px'}} src={count === 1 ? small_checkmark : count === 2 ? small_square :  semiCheckbox} alt='checkmark' />                                  
    
          <p className='text_elip' style={{padding:'0',margin:0,width:'133px'}}>{ticket.Name}</p>
         
         
          {  showAlert === true || checkForAlertonChosen(ticket) === true || checkForAlertonNotChosen(ticket) === true ?  
         <img style={{paddingTop:'2px'}} src={alertIcon} alt='alert-icon-tri' /> : ''}

          </div>

  
  )
}

export default TriCheckbox2